module.exports = __webpack_public_path__ + "media/images/plans/plan-photowedding-c4526a43408178f9f3bbbba92666a0bd.png";